import { useEffect } from "react";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { PaymentTypeEnum, OrderPaymentStatusEnum, CheckoutNotificationStatus } from "../../../utils/enumsUtil";

const ActionButtons = ({
    rowData,
    loadOrders,
    reduxModifyOrderPaymentType,
    successfulModifyOrderPaymentType,
    errorModifyOrderPaymentType,
    reduxModifyOrderPaymentTypeReset,
    reduxCancelOrder,
    successfulCancelOrder,
    errorCancelOrder,
    reduxCancelOrderReset,
    reduxReSendOrder,
    successfulReSendOrder,
    errorReSendOrder,
    reduxReSendOrderReset
}) => {

    useEffect(() => {
        if (successfulModifyOrderPaymentType) {
            Swal.fire({
                title: 'Proceso exitoso',
                text: 'Tipo de pago modificado correctamente',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            })
            loadOrders();
        }

        if (errorModifyOrderPaymentType) {
            Swal.fire({
                title: 'Proceso fallido',
                text: 'Error al modificar el tipo de pago',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        }

        reduxModifyOrderPaymentTypeReset();
    }, [successfulModifyOrderPaymentType, errorModifyOrderPaymentType]);

    useEffect(() => {
        if (successfulCancelOrder) {
            Swal.fire({
                title: 'Proceso exitoso',
                text: 'Orden cancelada correctamente',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            })
            loadOrders();
        }

        if (errorCancelOrder) {
            Swal.fire({
                title: 'Proceso fallido',
                text: 'Error al cancelar la orden',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        }

        reduxCancelOrderReset();
    }, [successfulCancelOrder, errorCancelOrder]);

    useEffect(() => {
        if (successfulReSendOrder) {
            Swal.fire({
                title: 'Proceso exitoso',
                text: 'Link de pago enviado correctamente',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            })
            loadOrders();
        }

        if (errorReSendOrder) {
            Swal.fire({
                title: 'Proceso fallido',
                text: 'Error al enviar el link de pago',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        }

        reduxReSendOrderReset();
    }, [successfulReSendOrder, errorReSendOrder]);
    
    const handleConfirmCOD = (rowData) => {
        Swal.fire({
            title: 'Confirmar COD',
            text: '¿Está seguro que desea confirmar el pago contra entrega (COD) para esta orden?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                reduxModifyOrderPaymentType({
                    hashId: rowData.hashId || rowData.order.hashId,
                    paymentType: PaymentTypeEnum.COD,
                })
            }
        })
    }

    const handleCancelOrder = (rowData) => {
        Swal.fire({
            title: 'Anular Orden',
            text: '¿Está seguro que desea anular esta orden?, esta acción no se puede deshacer.',
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                reduxCancelOrder({
                    hashId: rowData.hashId || rowData.order.hashId,
                })
            }
        })
    }

    const handleReSendOrder = (rowData) => {
        Swal.fire({
            title: 'Reenviar Link',
            text: '¿Está seguro que desea reenviar el link de pago al cliente?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                reduxReSendOrder({
                    hashId: rowData.hashId || rowData.order.hashId,
                })
            }
        })
    }

    const validateNotificationAttempts = (rowData) => {
        return true;

        const preOrder = rowData.order.preOrder[0];
        return preOrder.whatsappNotificationQueue.length < 3;
    }

    return (
        <div className="d-flex gap-sm">
            <button
                title="Confirmar COD"
                className="btn btn-secondary btn-sm"
                type="button"
                onClick={e => handleConfirmCOD(rowData)}
            >
                <i className="fas fa-coins"></i>
            </button>
            {
                OrderPaymentStatusEnum[rowData.status] === OrderPaymentStatusEnum.EXPIRED &&
                (
                    <button
                        title="Enviar Link de Pago"
                        className="btn btn-secondary btn-sm"
                        type="button"
                        disabled={!validateNotificationAttempts(rowData)}
                        onClick={e => handleReSendOrder(rowData)}
                    >
                        <i className="far fa-paper-plane"></i>
                    </button>
                )
            }
            <button
                title="Anular Orden"
                className="btn btn-danger btn-sm"
                type="button"
                onClick={e => handleCancelOrder(rowData)}
            >
                <i className="fas fa-ban"></i>
            </button>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        successfulModifyOrderPaymentType: state.bankingOrdersState.successfulModifyOrderPaymentType,
        errorModifyOrderPaymentType: state.bankingOrdersState.errorModifyOrderPaymentType,
        successfulCancelOrder: state.bankingOrdersState.successfulCancelOrder,
        errorCancelOrder: state.bankingOrdersState.errorCancelOrder,
        successfulReSendOrder: state.bankingOrdersState.successfulReSendOrder,
        errorReSendOrder: state.bankingOrdersState.errorReSendOrder,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxModifyOrderPaymentType: (payload) =>
            dispatch({
                type: 'MODIFY_ORDER_PAYMENT_TYPE_REQUEST',
                value: payload
            }),
        reduxModifyOrderPaymentTypeReset: () =>
            dispatch({
                type: 'MODIFY_ORDER_PAYMENT_TYPE_RESET',
            }),
        reduxCancelOrder: (payload) =>
            dispatch({
                type: 'CANCEL_BANKING_ORDER_REQUEST',
                value: payload
            }),
        reduxCancelOrderReset: () =>
            dispatch({
                type: 'CANCEL_BANKING_ORDER_RESET',
            }),
        reduxReSendOrder: (payload) =>
            dispatch({
                type: 'RESEND_BANKING_ORDER_REQUEST',
                value: payload
            }),
        reduxReSendOrderReset: () =>
            dispatch({
                type: 'RESEND_BANKING_ORDER_RESET',
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionButtons);
